import { FeatureHighlightConfig } from './feature-highlight.model';

export type FeatureHighlightKey = 'bulk-edit-union-links' | 'bulk-edit-pension-links';

export function getFeatureHighlights(): Record<FeatureHighlightKey, FeatureHighlightConfig> {
  return {
    'bulk-edit-union-links': {
      addedDate: '2026-04-09',
      title: $localize`New: Change union`,
      body: $localize`Bulk edit unions for multiple employees at once.`,
    },
    'bulk-edit-pension-links': {
      addedDate: '2026-04-20',
      title: $localize`New: Change pension`,
      body: $localize`Bulk edit pensions for multiple employees at once.`,
    },
  };
}
